import React from "react";
import useNoteSettings from "./useNoteSettings";

const Settings = (props) => {

  const {
    hours,
    minutes,
    handleMinutesChange,
    handleHoursChange,
    handleSavePress,
    hoursError,
    minutesError,
    showSaved
  } = useNoteSettings();

  return (
    <div className="">
      <h1>Settings</h1>
      Notes{" "}
      <p>
        Set the Time frame window within which you want your users to be able to
        delete the shared notes.
      </p>
      <div className="rowFlex">
        <div className="formGroup colFlex wth-1 mr__1">
          <label>Hrs</label>
          <input
            type="number"
            value={hours}
            placeholder=""
            max={99}
            onChange={(e) => {
              handleHoursChange(e);
            }}
          />
          {hoursError && <p>Hours are required</p>}
        </div>
        <div className="formGroup colFlex wth-1">
          <label>Minutes</label>
          <input
            type="number"
            value={minutes}
            placeholder=""
            max={99}
            onChange={(e) => {
              handleMinutesChange(e);
            }}
          />
          {minutesError && <p>Minutes are required</p>}
        </div>
    
      </div>
      <button className="btn buttonGradient" onClick={handleSavePress}>
        Save
      </button>
      {showSaved && <label>Time frame Window has been configured.</label>}
    </div>
  );
};

export default Settings;
